"use strict";

$(document).ready(function () {
  if ($('.careers-module').length > 0) {
    shopsSelect();
    citySelect();
  }
});

function shopsSelect() {
  $('.shops-select').select2({
    minimumResultsForSearch: -1
  });
}

function citySelect() {
  $('.city-select').select2({
    minimumResultsForSearch: -1
  });
}